import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { sendAnalytics } from 'utils/analyticsUtils';
import { getRestrictionReason, accessErrorTypes } from '../../sessionBroadcastUtils';
import { notifyRedirectToTicketWidget } from '../../LoginPopover';
import { sendCustomClick } from '../../../../../utils/SnowplowUtils';
import {
    buttonTypes,
    loginSubCategory,
    registerSubCategory
} from '../../../../../constants/SnowplowConst';
import { loginClickOrigin, loginSpinnerOrigin } from '../../../../../constants/Enums';

const SessionAccessError = ({
    accessErrorType,
    ticketsSelectionData,
    session,
    siteConf: { color1, isWidget },
    eventUrls: { registrationsUrl },
    isWebLoginV2Used,
    onLoginClick,
    event,
    setLoginV2SpinnerOrigin,
    setLoginV2OffsetTop,
    loginV2LoadingState,
}) => {
    if (!accessErrorType) {
        return null;
    }

    const backgroundColor = color1;

    const handleLogin = (e) => {
        sendCustomClick(buttonTypes.login, loginSubCategory.accessErrorBanner, e.currentTarget);
        sendAnalytics('loginClick', {
            clickOrigin: loginClickOrigin.session.restriction,
            sessionId: session?.id,
        });
        const isLoginOnEmbedded = isWebLoginV2Used && isWidget && window.self !== window.parent;
        if (isLoginOnEmbedded) {
            setLoginV2OffsetTop?.(e.pageY);
        }
        onLoginClick();
        setLoginV2SpinnerOrigin?.(loginSpinnerOrigin.PRELIMINARY_ACCESS_ERROR);
    };

    const getTicketName = () => {
        const { tickets = [] } = ticketsSelectionData;
        if (tickets.length > 1) return '';
        return tickets[0]?.ticketName;
    };

    const getSubject = () => {
        if (accessErrorType === accessErrorTypes.contactList) {
            return 'Attendee is not listed on the contact list';
        }

        const ticketName = getTicketName();
        return ticketName
            ? `My ticket type (${ticketName}) does not have an access to the session ${session?.title} (sessionId: ${session.id})`
            : `My ticket types don't have access to the session ${session?.title} (sessionId: ${session.id})`;
    };

    const showErrorMessage = () => getRestrictionReason({
        reason: accessErrorType,
        parsed: true,
        tickets: ticketsSelectionData?.tickets,
    });

    const showContactOrganizer = () =>
        [accessErrorTypes.contactList, accessErrorTypes.ticketType].includes(accessErrorType);

    const handleRegister = (e) => {
        sendCustomClick(buttonTypes.register, registerSubCategory.accessErrorBanner, e.currentTarget);
        notifyRedirectToTicketWidget();
    };

    const isLoginV2Loading = loginV2LoadingState.isLoading
        && loginV2LoadingState.spinnerOrigin === loginSpinnerOrigin.PRELIMINARY_ACCESS_ERROR;

    return (
        <CSSTransitionGroup
            transitionName='slide-down'
            transitionEnter={false}
            transitionLeave={false}
            transitionAppear
        >
            <div
                key={accessErrorType}
                className="session-access-error-wrapper"
            >
                <div
                    className="session-access-error agenda-font-family font-size-16"
                    style={{ backgroundColor }}
                >
                    <div className="animated-content">
                        <div>
                            {showErrorMessage()}
                        </div>
                        {accessErrorType === accessErrorTypes.unauthenticated && (
                            <div className="cta-container cta-container-access-error">
                                <div className="cta-button-bg">
                                    <a
                                        href={registrationsUrl}
                                        onClick={handleRegister}
                                        className="cta-button cta-button-small font-size-12 custom-color color-1 color-4-border color-1-hover-opacity-outline"
                                        target="_top"
                                    >
                                        Register
                                    </a>
                                </div>
                                <div className="cta-button-bg margin-left-small">
                                    <button
                                        onClick={handleLogin}
                                        className="cta-button cta-button-small font-size-12 color-1-background color-1-hover-opacity color-4-border"
                                    >
                                        {isLoginV2Loading ? (
                                            <i className="fa fa-spinner fa-spin font-size-17" />
                                        ) : (
                                            'Login'
                                        )}
                                    </button>
                                </div>

                            </div>
                        )}
                        {showContactOrganizer() && (
                            <Mailto
                                email={event['support-email']}
                                subject={getSubject()}
                            >
                                Contact organizer
                            </Mailto>
                        )}
                    </div>
                </div>
            </div>
        </CSSTransitionGroup>
    );
};

const Mailto = ({ email = '', subject = '', children }) => (
    <div className="cta-button-bg cta-container-access-error">
        <a
            className="cta-button cta-button-mail-to cta-button-small font-size-12 custom-color color-1-background color-1-hover-opacity color-4-border"
            href={`mailto:${email}?subject=${encodeURIComponent(subject)}`}
            target="_top"
        >
            {children}
        </a>
    </div>
);

export default SessionAccessError;
